<div class="services-section-container">
  <div class="services-title">
    СЕРВИСЫ
  </div>
  <div class="services-list">
    <div *ngFor="let item of Services; index as i"
         class="services-list-item"
         [class]="getActive('services-' + i) ? 'services-list-item-active' : ''"
         [id]="'services-' + i">
      <div class="services-list-item-number">{{ item.number }}</div>
      <div  class="services-list-item-info">
        <div class="services-list-item-info-title">{{ item.title }}</div>
        <div class="services-list-item-info-text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</div>
